import BenefitsBanner from './BenefitsBanner';

export default BenefitsBanner;
